import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlCreationOptions } from '@angular/router';
import type { BaseRouteParams } from '@eliboo/shared/micro-ng';

import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { DelonTokenService } from '@eliboo/micro-ng/auth-delon';
import { ELIBOO_ERROR_CODE, ElibooError } from '@eliboo/shared/common';
import { catchError, map, of, switchMap } from 'rxjs';
export function bizAuthGuardFn(
  getRedirectParamsFn: (
    injector: Injector,
    errMsg: string,
    rawError: unknown,
  ) => {
    commands: string[];
    login_url?: string[];
    navigationExtras?: UrlCreationOptions;
  },
) {
  const bizCanActivateFn: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const injector = inject(Injector);
    const tokenSrv = inject(DelonTokenService);
    const params = route.queryParams as BaseRouteParams;
    return of(null).pipe(
      switchMap(() => (commonInit(tokenSrv))),
      map(() => true),
      catchError((err) => {
        let errMsg = '';
        if (err instanceof ElibooError) {
          errMsg = err.message;
          console.error('taxInitResolver.ElibooError', err, err.cause, err.code);
          if (err.code === "token-bad" || err.code === "token-expired") {
            const { navigationExtras, login_url } = getRedirectParamsFn(injector, errMsg, err);
            if (login_url) {
              return of(new RedirectCommand(router.createUrlTree(login_url)));
            }
          }
        } else if (err instanceof Error) {
          errMsg = err.message;
          console.error('taxInitResolver.Error', err);
        } else if (err instanceof HttpErrorResponse) {
          const error = err.error;
          errMsg = error.msg ?? error.error_description ?? err.message;
          console.error('taxInitResolver.HttpErrorResponse', err);
        } else {
          console.error('taxInitResolver.UnknownError', err);
          errMsg = err.toString();
        }
        const { commands, navigationExtras } = getRedirectParamsFn(injector, errMsg, err);
        return of(new RedirectCommand(router.createUrlTree(commands, navigationExtras)));
      }),
    );
  };
  return bizCanActivateFn;
}
function commonInit(tokenSrv: DelonTokenService) {
  if (tokenSrv.isExpired()) {
    tokenSrv.clear(); // TODO 判断是否可以刷新token
    throw new ElibooError('token-expired', ELIBOO_ERROR_CODE['token-expired']);
  }
  return of(null);
}
